import PageHeadComponent from "@src/components/organisms/page-head/page-head.component";
import React from "react";
import FeatherIcon from "feather-icons-react";
import { breadCrumbs } from "../notification-list/model/notification-list.constants";
import FormBuilderComponent from "@molecules/form-builder/form-builder.component";
import CardComponent from "@atoms/card/card.component";
import PageWrapperComponent from "@src/components/organisms/page-wrapper/page-wrapper.component";

const ActionContent = ({ handleSaveClick, handleBackClick }) => {
  return (
    <>
      <button
        type="button"
        className="btn btn-primary btn-sm"
        onClick={handleSaveClick}
      >
        <FeatherIcon icon="save" size={17} />
      </button>

      <button
        type="button"
        className="btn btn-outline-primary btn-sm ml-2"
        onClick={handleBackClick}
      >
        <FeatherIcon icon="arrow-left" size={17} />
      </button>
    </>
  );
};

const NotificationCreateTemplateComponent = ({
  templateModal: { formTriggers, formInputs },
  templateEvents: {
    handleNotificationSubmit,
    handleTriggerClick,
    handleBackClick,
  },
}) => {
  return (
    <PageWrapperComponent>
      <PageHeadComponent
        title={"Create Notification"}
        breadCrumbs={[
          ...breadCrumbs,
          {
            name: "Create ",
            menu_url: "/user-administration/notification/create",
          },
        ]}
        actionContent={
          <ActionContent
            handleSaveClick={() => handleTriggerClick("SUBMIT")}
            handleBackClick={handleBackClick}
          />
        }
      />

      <CardComponent>
        <FormBuilderComponent
          inputFields={formInputs}
          submitTrigger={formTriggers.submitTrigger}
          onSubmit={handleNotificationSubmit}
        />
      </CardComponent>
    </PageWrapperComponent>
  );
};

export default NotificationCreateTemplateComponent;
